<template>
    <div class="app-container">
      <el-form ref="queryForm" :inline="true" label-width="120px">
        <el-form-item :label="$t('RoleManagement.child.name')" prop="roleName">
          <BjInput
            :maxlength="MAX_LENGTH.DEFAULT"
            :value="roleName"
            disabled
            :placeholder="$t('inputText')"
            clearable
          />
        </el-form-item>
      </el-form>
      <el-row :gutter="10" class="mb8">
        <el-col :span="1.5" class="top-left-btn">
          <el-button type="primary" :disabled="multiple" class="delete-btn" @click="onDeleteSelected"
            >{{ $t('delText') }}</el-button
          >
        </el-col>
        <el-col :span="1.5" class="top-left-btn">
          <el-button type="primary" class="main-btn" @click="handleAdd">{{ $t('RoleManagement.child.add') }}</el-button>
        </el-col>

        <el-col :span="1.5">
          <el-button @click="complete('BusinessUserRoleAdminCSG')">{{ $t('backText') }}</el-button>
        </el-col>
      </el-row>
      <el-table
        ref="table"
        v-loading="loading"
        :data="userTableData"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column :label="$t('RoleManagement.child.role')" align="center" prop="loginName" />
        <el-table-column :label="$t('RoleManagement.child.rolename')" align="center" prop="realName" />
      </el-table>
      <pagination
        v-show="queryParams.total > 0"
        :total="queryParams.total"
        :page.sync="queryParams.page"
        :limit.sync="queryParams.size"
        @pagination="getList"
      />

      <BjDialogList
        ref="dialogList"
        :config="dialogListConfig"
        :disabled="disabledIds"
        multiple
        @confirm="onConfirmDialogList"
      />
    </div>
  </template>
  <script>
  import viewMiXin from '@/utils/view-mixin.js';
  // import pageMiXin from '@/utils/page-mixin.js';
  import { roleApi, userApi } from '@/api';
  export default {
    name: 'BusinessUserRoleAllotUser',
    mixins: [viewMiXin],
    data() {
      return {
        dialogListConfig: {
          title: this.$t('RoleManagement.child.add'),
          columns: [
            {
              prop: 'loginName',
              label: this.$t('RoleManagement.child.role'),
            },
            {
              prop: 'realName',
              label: this.$t('RoleManagement.child.rolename'),
            },
          ],
          search: [
            {
              placeholder: this.$t('RoleManagement.common.ps'),
              key: 'realName',
            },
          ],
          actionApi: userApi.getUserList,
          defaultQuery: {
            belongTo: this.$route.query.belongTo || 2,
          },
          query: 'userGroupId',
        },
        // 遮罩层
        loading: false,

        queryParams: {
          page: 1,
          size: 20,
          total: 0,
        },
        userTableData: [],
        disabledIds: [],
        // 选中数组
        ids: [],
        selectedRow: [],
        // 非单个禁用
        single: true,
        // 非多个禁用
        multiple: true,
        /** 弹窗 */
        dialogVisible: false,
        /** 弹窗数据 */
        dialogData: [],
        /** 标题 */
        title: '选择用户',
        userGroupInfo: null,
      };
    },
    computed: {
      roleId() {
        return this.$route.query.roleId || '';
      },
      roleName() {
        return this.$route.query.roleName || '';
      },
    },
    watch: {
      roleId: {
        handler(v) {
          if (v) {
            this.getUserListByRoleId(v);
          }
        },
        immediate: true,
      },
    },
    methods: {
      getList() {
        this.getUserListByRoleId();
      },
      /** 保存 */

      /**
       * START 添加操作
       */
      handleAdd() {
        this.disabledIds = this.userTableData.map(item => {
          return item.id;
        });
        this.$refs.dialogList.show();
      },
      onConfirmDialogList(data) {
        const USERLIST = data.map(e => {
          return {
            _innerMap: {},
            memberId: e.id,
            roleId: this.roleId,
          };
        });
        userApi
          .addUserRoles({
            BjBody: USERLIST,
          })
          .then(res => {
            if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              this.getUserListByRoleId();
            }
          });
      },
      /** END */
      /** 删除操作 */
      onDeleteSelected() {
        const USERLIST = this.selectedRow.map(e => {
          return {
            _innerMap: {},
            memberId: e.id,
            roleId: this.roleId,
          };
        });
        userApi
          .deleteUserRoles({
            BjBody: USERLIST,
          })
          .then(res => {
            if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              this.getUserListByRoleId();
            }
          });
      },
      /** 获取列表 */
      getUserListByRoleId(v) {
        v = v || this.roleId;
        roleApi
          .getUserListByRoleId({
            roleId: v,
            ...this.queryParams,
          })
          .then(res => {
            if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
              this.userTableData = res.content;
              this.queryParams.total = res.totalElements || res.content.length;
            }
          });
      },
      handleDelete() {
      },
      // 多选框选中数据
      handleSelectionChange(selection) {
        this.selectedRow = [].concat(selection);
        this.ids = selection.map(item => item.userId);
        this.single = selection.length !== 1;
        this.multiple = !selection.length;
      },
      /** 取消 */
      handleClose() {
        this.dialogVisible = false;
      },
      /** 修改size */
      getPageList() {
      },
      /** 搜索 */
      dialogSearch() {
      },
      /** 多选 */
      dialogSelectionChange(data) {
      },
      dialogConfirm() {
        this.dialogVisible = false;
      },
    },
  };
  </script>
